module.exports = __webpack_public_path__ + "static/media/fiori1.7fce981b.png";